import { useEffect, useState } from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Stack,
  TextField,
} from '@mui/material';

/**
 * 프리셋 생성 / 이름·설명 수정 다이얼로그
 *
 * mode = 'add'  : 새 프리셋. sourcePresetId 를 고르면 카메라/씬까지 복제됩니다.
 * mode = 'edit' : 이름/설명만 수정 (카메라·씬은 본 화면의 그리드에서 편집)
 */
const PresetDialog = ({ open, mode, preset, presets, onClose, onSave }) => {
  const [presetName, setPresetName] = useState('');
  const [description, setDescription] = useState('');
  const [sourcePresetId, setSourcePresetId] = useState('');
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (!open) return;
    if (mode === 'edit' && preset) {
      setPresetName(preset.presetName ?? '');
      setDescription(preset.description ?? '');
      setSourcePresetId('');
    } else {
      setPresetName('');
      setDescription('');
      // 기본값으로 현재 선택된 프리셋을 복제 원본으로 제안합니다.
      setSourcePresetId(preset?.presetId ?? '');
    }
  }, [open, mode, preset]);

  const handleSave = async () => {
    if (!presetName.trim()) {
      alert('프리셋 이름을 입력하세요.');
      return;
    }
    setSaving(true);
    try {
      await onSave({
        presetName: presetName.trim(),
        description: description.trim(),
        sourcePresetId: mode === 'add' && sourcePresetId !== '' ? sourcePresetId : undefined,
      });
    } finally {
      setSaving(false);
    }
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle>{mode === 'add' ? '새 프리셋' : '프리셋 정보 수정'}</DialogTitle>
      <DialogContent>
        <Stack spacing={3} sx={{ mt: 2 }}>
          <TextField
            label="프리셋 이름"
            value={presetName}
            onChange={(e) => setPresetName(e.target.value)}
            fullWidth
            autoFocus
            inputProps={{ maxLength: 100 }}
          />
          <TextField
            label="설명"
            value={description}
            onChange={(e) => setDescription(e.target.value)}
            fullWidth
            multiline
            minRows={2}
            inputProps={{ maxLength: 255 }}
          />
          {mode === 'add' && (
            <FormControl fullWidth>
              <InputLabel id="source-preset-label">복제할 원본</InputLabel>
              <Select
                labelId="source-preset-label"
                label="복제할 원본"
                value={sourcePresetId}
                onChange={(e) => setSourcePresetId(e.target.value)}
              >
                <MenuItem value="">
                  <em>빈 프리셋으로 시작</em>
                </MenuItem>
                {presets.map((p) => (
                  <MenuItem key={p.presetId} value={p.presetId}>
                    {p.presetName} (카메라 {p.cameraCount} / 씬 {p.sceneCount})
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          )}
        </Stack>
      </DialogContent>
      <DialogActions sx={{ px: 6, pb: 4 }}>
        <Button onClick={onClose} color="inherit">
          취소
        </Button>
        <Button onClick={handleSave} variant="contained" disabled={saving}>
          저장
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default PresetDialog;
